<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path
      d="M12.2499 12.0001C12.6641 12.0001 12.9999 12.3359 12.9999 12.7501C12.9998 13.1643 12.6641 13.5001 12.2499 13.5001H3.74989C3.33575 13.5001 2.99995 13.1643 2.99989 12.7501C2.99989 12.3359 3.33571 12.0002 3.74989 12.0001H12.2499Z"
      fill="#FFD651"
    />
    <path
      d="M10.7499 9.50013C11.1641 9.50013 11.4999 9.83592 11.4999 10.2501C11.4998 10.6643 11.1641 11.0001 10.7499 11.0001H5.24989C4.83575 11.0001 4.49995 10.6643 4.49989 10.2501C4.49989 9.83595 4.83571 9.50018 5.24989 9.50013H10.7499Z"
      fill="#FFD651"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.82948 3.79115C6.78922 2.11161 9.21057 2.11161 10.1703 3.79115L14.724 11.7599C15.6763 13.4265 14.4731 15.5001 12.5536 15.5001H3.44618C1.52676 15.5 0.323585 13.4265 1.27577 11.7599L5.82948 3.79115ZM9.30214 4.28724C8.72629 3.27952 7.27349 3.27952 6.69764 4.28724L2.14393 12.256C1.5727 13.2559 2.29459 14.5 3.44618 14.5001H12.5536C13.7053 14.5001 14.4272 13.2559 13.8558 12.256L9.30214 4.28724Z"
      fill="#FFD651"
    />
  </svg>
</template>
